/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsUserControllerArchiveMutationRequest,
  TelegramProductsUserControllerArchiveMutationResponse,
  TelegramProductsUserControllerArchive401,
} from '../../types/TelegramProductsUserControllerArchive.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramProductsUserArchive } from '../../methods/telegramProductsUserArchive.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramProductsUserArchiveMutationKey = () => [{ url: '/api/user/telegram/products/archive' }] as const;

export type TelegramProductsUserArchiveMutationKey = ReturnType<typeof telegramProductsUserArchiveMutationKey>;

/**
 * {@link /api/user/telegram/products/archive}
 */
export function useTelegramProductsUserArchive<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramProductsUserControllerArchiveMutationResponse,
      ResponseErrorConfig<TelegramProductsUserControllerArchive401>,
      { data: TelegramProductsUserControllerArchiveMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramProductsUserControllerArchiveMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramProductsUserArchiveMutationKey();

  return useMutation<
    TelegramProductsUserControllerArchiveMutationResponse,
    ResponseErrorConfig<TelegramProductsUserControllerArchive401>,
    { data: TelegramProductsUserControllerArchiveMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramProductsUserArchive(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
